import request from "./../utils/request";

export function getSubjects(limit = 25, page = 1) {
    return request({
        url: `/subjects/pagination`,
        method: "get",
        params: {
            pageCount: page,
            perPage: limit,
        },
    });
}

export function createSubject(data) {
    return request({
        url: "/subjects/",
        method: "post",
        data: data,
    });
}

export function updateSubject(id, data) {
    return request.put(`/subjects/${id}`, data);
}

export function deleteSubject(id) {
    return request.delete(`/subjects/${id}`);
}

export function getSubjectsBySiteId(siteId, limit = 25, page = 1) {
    return request({
        url: `/subjects/get-all/site/${siteId}`,
        method: "get",
        params: {
            pageCount: page,
            perPage: limit,
        },
    });
}
